module.exports = __webpack_public_path__ + "assets/img/one-tab5-on.5427f286.png";